module.exports = __webpack_public_path__ + "static/img/7.1c30350.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/5/1/sp/7.png
// module id = bTLb
// module chunks = 0